import { onDomReady } from 'Shared/utils/dom-ready';

onDomReady(() => {
   document.querySelectorAll('.js-status-cancel').forEach(el => {
      const notification = el.parentElement;
      const container = notification.parentElement;

      el.addEventListener('click', () => {
         if (container.children.length <= 1) {
            container.remove();
         } else {
            notification.remove();
         }
      });
   });
});
